import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import Main from '../../../component/Main';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect';
import Loading from '../../../component/common/loading/Loading';
import generateFidelityList from './generate_fidelity_list';
import FidelityExcelDownload from './FidelityExcelDownload';
import useModalStore from '../../../zustand/store/useModalStore';

import '../../../css/data-grid.css';
import { useDynamicStyle } from '../../../hooks/useDynamicStyle';
import { Search16w } from '../../../images/icons/icons_component';

// 엑셀 다운로드 컬럼 너비 설정값
const COMP_SEND_COL_WIDTHS = [7, 17, 17, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12];

// 비고 - 엑셀 다운로드에 그대로 포함되도록 table 로 구성
const COMP_SEND_DESC_TEXTS = [
    '· 정상저장률 : 지침서코드와 동일한 경우',
    '· 미상저장률 : 자료가 없는 경우 \'default\' 전송을 의미',
    '· 미입력률 : 전송값이 전혀 없는 경우 (null 로 전송된 경우, 즉 \'default\' 전송도 없는 경우)',
    '· 재검토율 : 오류내역은 아니지만 확인이 필요한 경우를 의미',
    '· 오류율 : 입력지침서에 지정된 코드와 정상 범위 이외의 값을 전송 한 경우를 의미',
    '· 퇴원정보의 미입력률에는 재원중인 환자도 포함될 수 있음.'
];

const CompSendStatMonthly = () => {

    const today = new Date();
    const currentYear = today.getFullYear();
    let currentMonth = today.getMonth() + 1;
    if (currentMonth < 10) {
        currentMonth = '0' + currentMonth;
    }

    const [searchParams, setSearchParams] = useState({
        searchYear: currentYear,
        searchMonth: currentMonth,
        searchEmog: localStorage.getItem('userAuth') === 'J003' ? localStorage.getItem('useremcd') : '',
        searchGrdc: localStorage.getItem('userAuth') === 'J003' ? localStorage.getItem('emoggrdc2') : '',
        searchLoca: localStorage.getItem('userAuth') === 'J003' ? localStorage.getItem('emogloca') : '',
        searchType: '01',
        fromindt: currentYear + currentMonth + '01',
        toindt: currentYear + currentMonth + '31',
        beforefromindt: currentMonth - 1 === 0 ? currentYear - 1 + '1201' : currentYear + currentMonth - 1 + '01',
        beforetoindt: currentMonth - 1 === 0 ? currentYear - 1 + '1231' : currentYear + currentMonth - 1 + '31'
    });

    const [searchBeforeParams, setSearchBeforeParams] = useState({
        searchYear: currentYear,
        searchMonth: currentMonth,
        searchEmog: localStorage.getItem('userAuth') === 'J003' ? localStorage.getItem('useremcd') : '',
        searchGrdc: localStorage.getItem('userAuth') === 'J003' ? localStorage.getItem('emoggrdc2') : '',
        searchLoca: localStorage.getItem('userAuth') === 'J003' ? localStorage.getItem('emogloca') : '',
        searchType: '01',
        fromindt: currentMonth - 1 === 0 ? currentYear - 1 + '1201' : currentYear + currentMonth - 1 + '01',
        toindt: currentMonth - 1 === 0 ? currentYear - 1 + '1231' : currentYear + currentMonth - 1 + '31'
    });

    const [isSearched, setIsSearched] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [fidelityData, setFidelityData] = useState([{}]);
    const [fidelityBeforeData, setFidelityBeforeData] = useState([{}]);
    const [totalItems, setTotalItems] = useState([0, 0]);

    // 엑셀 파일명을 '조회 시점' 기준으로 고정하기 위한 state
    const [excelInfo, setExcelInfo] = useState({ emogdesc: '', period: '' });
    // 엑셀 다운로드 대상 ref
    const tableRef = useRef(null);

    // toast modal open function
    const showNotiModal = useModalStore(state => state.showNotiModal);

    const search = () => {
        if (searchParams.searchEmog === '') {
            showNotiModal('먼저 해당 응급의료기관을 선택하십시오.');
        } else {
            setIsLoading(true);
            getfidelityData();
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        if (name === 'searchType') {
            setIsSearched(false);
        }
        if (name === 'searchYear' || name === 'searchMonth' || name === 'searchEmog') {
            const year = name === 'searchYear' ? value : searchParams.searchYear;
            const month = name === 'searchMonth' ? value : searchParams.searchMonth;

            const paddedMonth = String(month).padStart(2, '0');
            const prevMonth = parseInt(month) - 1 || 12;
            const prevYear = prevMonth === 12 ? parseInt(year) - 1 : parseInt(year);
            const paddedPrevMonth = String(prevMonth).padStart(2, '0');

            const fromindt = `${year}${paddedMonth}01`;
            const toindt = `${year}${paddedMonth}31`;
            const beforefromindt = `${prevYear}${paddedPrevMonth}01`;
            const beforetoindt = `${prevYear}${paddedPrevMonth}31`;

            newParams.fromindt = fromindt;
            newParams.toindt = toindt;

            const updatedBeforeParams = {
                ...newParams,
                fromindt: beforefromindt,
                toindt: beforetoindt
            };

            setSearchParams(newParams);
            setSearchBeforeParams(updatedBeforeParams);
        } else {
            setSearchParams(newParams);
        }
    };

    const [bodylist, setBodyList] = useState([]);
    const head = ['항목', '정상(%)', '증감', '미상(%)', '증감', '미입력(%)', '증감', '재검토(%)', '증감', '오류(%)', '증감'];
    const except_body = ['PTMIHIBP', 'PTMILOBP', 'PTMIPULS', 'PTMIBRTH', 'PTMIBDHT', 'PTMIVOXS'];

    const bodyData = async () => {
        try {
            const response = await axios.get('/ptmiapi/fidelity_list.do',
                { params: { listType: 'ALL' } }
            );

            setBodyList(response.data.fidelitylist);

        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    }

    const getfidelityData = async () => {
        try {
            const response = await axios.get('/ptmiapi/fidelity_data.do',
                { params: searchParams }
            );
            setFidelityData(generateFidelityList(bodylist, response.data, searchParams.searchType));

            const response2 = await axios.get('/ptmiapi/fidelity_data.do',
                { params: searchBeforeParams }
            );

            setFidelityBeforeData(generateFidelityList(bodylist, response2.data, searchBeforeParams.searchType));

            const cnt = response.data?.statInfo.TOTAL_CNT1 ?? 0;
            const beforeCnt = response2.data?.statInfo.TOTAL_CNT1 ?? 0;
            setTotalItems([beforeCnt, cnt]);
            setExcelInfo({
                emogdesc: response.data?.statInfo.EMOGDESC,
                period: searchParams.fromindt.substring(0, 6)
            });

            setIsSearched(true);
            setIsLoading(false);

        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    }

    useEffect(() => {
        bodyData();
    }, []);

    // Dynamic Style Hook
    const { fontColor, primaryBackColor, borderColorGray } = useDynamicStyle();

    return (
        <Main>
            <div className='com-search'>
                <table>
                    <colgroup>
                        <col width='10%' />
                        <col width='20%' />
                        <col width='10%' />
                        <col width='20%' />
                        <col width='10%' />
                        <col width='20%' />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={true}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                                exValidation={true}
                            />
                        </tr>
                        <tr>
                            <th>내원기간</th>
                            <td>
                                <select id='searchYear'
                                    name='searchYear'
                                    value={searchParams.searchYear}
                                    onChange={handleInputChange}
                                >
                                    {Array.from({ length: 10 }, (_, i) => {
                                        const year = (currentYear - i).toString()
                                        return (
                                            <option key={year} value={year}>
                                                {year} 년
                                            </option>
                                        );
                                    })}
                                </select>
                                &ensp;
                                <select id='searchMonth'
                                    name='searchMonth'
                                    value={searchParams.searchMonth}
                                    onChange={handleInputChange}
                                >
                                    {Array.from({ length: 12 }, (_, i) => {
                                        const month = (i + 1).toString().padStart(2, '0');
                                        return (
                                            <option key={month} value={month}>
                                                {month} 월
                                            </option>
                                        );
                                    })}
                                </select>
                            </td>
                            <th>기관구분</th>
                            <td colSpan='3'>
                                <select id='searchType'
                                    name='searchType'
                                    value={searchParams.searchType}
                                    onChange={handleInputChange}
                                >
                                    <option value='01'>센터형</option>
                                    <option value='02'>기관형</option>
                                </select>
                                <span className='co_red ml-2'>* 표출되는 항목에 영향을 줍니다.</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className='search_btn_wrapper'>
                <span className='total_items'>전월 : 총&nbsp;<strong className={fontColor}>{totalItems[0]}</strong>건 / 금월 : 총&nbsp;<strong className={fontColor}>{totalItems[1]}</strong>건</span>
                <div className='btn_container'>
                    <button onClick={search} disabled={isLoading ? 'disabled' : ''} className={`search_btn ${primaryBackColor}`}><Search16w />검색</button>
                    <FidelityExcelDownload
                        targetRef={tableRef}
                        disabled={!(isSearched && !isLoading)}
                        excelFileName={`충실도_월별전송내역비교_${excelInfo.emogdesc}_${excelInfo.period}(${searchParams.searchType === '01' ? '센터형' : '기관형'})`}
                        colWidths={COMP_SEND_COL_WIDTHS}
                    />
                </div>
            </div>
            {isLoading && <Loading />}
            <div ref={tableRef} className={`flex flex-col flex-grow min-h-0 ${isLoading ? 'hidden' : ''}`}>
                <div className='data_grid_container'>
                    <hr className={`border-t-2 mr-1-1 ${borderColorGray}`}/>
                    <div className={`data_list_table ${isSearched ? 'grid-animation' : ''}`}>
                        <table>
                            <colgroup>
                                <col width='4%' />
                                <col width='9%' />
                                <col width='9%' />
                            </colgroup>

                            <thead>
                                <tr className='table_header'>
                                    {head.map((content, index) => (
                                        <th colSpan={index === 0 ? 3 : index % 2 !== 0 ? 2 : 1} rowSpan={index === 0 ? 2 : 1} key={index}>
                                            {content}
                                        </th>
                                    ))}
                                </tr>
                                <tr className='table_header'>
                                    {Array.from({ length: 15 }, (_, i) => {
                                        if (i % 3 == 0) return (<th key={i}>{searchParams.searchMonth - 1 === 0 ? 12 : String(searchParams.searchMonth - 1).padStart('2', 0)}월</th>)
                                        if (i % 3 == 1) return (<th key={i}>{searchParams.searchMonth}월</th>)
                                        if (i % 3 == 2) return (<th key={i}>(%p)</th>)
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {bodylist.filter(content => !(searchParams.searchType === '02' && content.FIDELITY_TYPE === '02')).map((content, index) => (
                                    <tr key={index + 1} className={searchParams.searchType === '02' && content.FIDELITY_TYPE === '02' ? 'hidden' : content.FIDELITY_TYPE === '02' ? '' : ' colored'} data-cls={content.SEQ < 10 ? '0' + (content.SEQ) : content.SEQ}>
                                        <td>{index + 1}</td>
                                        {content.FIDELITY_CODE === 'PTMIHIBP' ? <td className='middle' rowSpan='6'><span>내원 시<br /> 활력징후</span></td> : ''}
                                        <td colSpan={except_body.includes(content.FIDELITY_CODE) ? '1' : '2'}>{content.FIDELITY_NAME}</td>
                                        <td>{isSearched ? fidelityBeforeData && fidelityBeforeData.filter(data => data.FIDELITY_ID === content.FIDELITY_CODE)[0].ORG_NORMAL : '0.0'}</td>
                                        <td>{isSearched ? fidelityData && fidelityData.filter(data => data.FIDELITY_ID === content.FIDELITY_CODE)[0].ORG_NORMAL : '0.0'}</td>
                                        <td>{isSearched ? ((fidelityData && fidelityData.filter(data => data.FIDELITY_ID === content.FIDELITY_CODE)[0].ORG_NORMAL) - (fidelityBeforeData && fidelityBeforeData.filter(data => data.FIDELITY_ID === content.FIDELITY_CODE)[0].ORG_NORMAL)).toFixed(2) : '0.0'}</td>
                                        <td>{isSearched ? fidelityBeforeData && fidelityBeforeData.filter(data => data.FIDELITY_ID === content.FIDELITY_CODE)[0].ORG_UNKNOWN : '0.0'}</td>
                                        <td>{isSearched ? fidelityData && fidelityData.filter(data => data.FIDELITY_ID === content.FIDELITY_CODE)[0].ORG_UNKNOWN : '0.0'}</td>
                                        <td>{isSearched ? ((fidelityData && fidelityData.filter(data => data.FIDELITY_ID === content.FIDELITY_CODE)[0].ORG_UNKNOWN) - (fidelityBeforeData && fidelityBeforeData.filter(data => data.FIDELITY_ID === content.FIDELITY_CODE)[0].ORG_UNKNOWN)).toFixed(2) : '0.0'}</td>
                                        <td>{isSearched ? fidelityBeforeData && fidelityBeforeData.filter(data => data.FIDELITY_ID === content.FIDELITY_CODE)[0].ORG_BLANK : '0.0'}</td>
                                        <td>{isSearched ? fidelityData && fidelityData.filter(data => data.FIDELITY_ID === content.FIDELITY_CODE)[0].ORG_BLANK : '0.0'}</td>
                                        <td>{isSearched ? ((fidelityData && fidelityData.filter(data => data.FIDELITY_ID === content.FIDELITY_CODE)[0].ORG_BLANK) - (fidelityBeforeData && fidelityBeforeData.filter(data => data.FIDELITY_ID === content.FIDELITY_CODE)[0].ORG_BLANK)).toFixed(2) : '0.0'}</td>
                                        <td>{isSearched ? fidelityBeforeData && fidelityBeforeData.filter(data => data.FIDELITY_ID === content.FIDELITY_CODE)[0].ORG_REVIEW : '0.0'}</td>
                                        <td>{isSearched ? fidelityData && fidelityData.filter(data => data.FIDELITY_ID === content.FIDELITY_CODE)[0].ORG_REVIEW : '0.0'}</td>
                                        <td>{isSearched ? ((fidelityData && fidelityData.filter(data => data.FIDELITY_ID === content.FIDELITY_CODE)[0].ORG_REVIEW) - (fidelityBeforeData && fidelityBeforeData.filter(data => data.FIDELITY_ID === content.FIDELITY_CODE)[0].ORG_REVIEW)).toFixed(2) : '0.0'}</td>
                                        <td>{isSearched ? fidelityBeforeData && fidelityBeforeData.filter(data => data.FIDELITY_ID === content.FIDELITY_CODE)[0].ORG_ERROR : '0.0'}</td>
                                        <td>{isSearched ? fidelityData && fidelityData.filter(data => data.FIDELITY_ID === content.FIDELITY_CODE)[0].ORG_ERROR : '0.0'}</td>
                                        <td>{isSearched ? ((fidelityData && fidelityData.filter(data => data.FIDELITY_ID === content.FIDELITY_CODE)[0].ORG_ERROR) - (fidelityBeforeData && fidelityBeforeData.filter(data => data.FIDELITY_ID === content.FIDELITY_CODE)[0].ORG_ERROR)).toFixed(2) : '0.0'}</td>
                                    </tr>
                                ))
                                }
                            </tbody>
                        </table>
                    </div>
                    <hr className='mr-1-1 co_border_gray'/>
                    {/* 범례 - 엑셀전용 table (그리드 최대 컬럼수에 맞춤) */}
                    <table>
                        <colgroup>
                            {Array.from({ length: COMP_SEND_COL_WIDTHS.length }).map((_, idx) => (
                                <col key={idx} width={`${100 / COMP_SEND_COL_WIDTHS.length}%`} />
                            ))}
                        </colgroup>
                        <tbody>
                            <tr>
                                <td colSpan={6} className='border-none py-0'>
                                    <div className='mt-2'>
                                        <div className='flex items-center'>
                                            <span className='st_row bold'>■ </span>
                                            <p className='ml-1'>&nbsp;센터급, 기관급 공통항목</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={COMP_SEND_COL_WIDTHS.length} className='border-none pt-0'></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {/* 비고 - 엑셀전용 table (그리드 최대 컬럼수에 맞춤) */}
                <table>
                    <colgroup>
                        {Array.from({ length: COMP_SEND_COL_WIDTHS.length }).map((_, idx) => (
                            <col key={idx} width={`${100 / COMP_SEND_COL_WIDTHS.length}%`} />
                        ))}
                    </colgroup>
                    <tbody>
                        {COMP_SEND_DESC_TEXTS.map((content, index) => (
                            <tr key={index}>
                                {/* (excel_black_text : 엑셀전용 클래스) */}
                                <td colSpan={COMP_SEND_COL_WIDTHS.length} className='border-none pt-0 excel_black_text'>
                                    <p className='ml-2'>{content}</p>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Main>
    )
}

export default CompSendStatMonthly;
